import React, { useState } from 'react';

function VacationForm({ employee, onSave, onClose }) {
  const today = (() => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
})();

  const [start, setStart] = useState(employee.vacation_start?.split('T')[0] || today);
  const [end, setEnd] = useState(employee.vacation_end?.split('T')[0] || today);
  const [error, setError] = useState('');

  // Считаем дни
  const days = start && end
    ? Math.ceil((new Date(end) - new Date(start)) / (1000 * 60 * 60 * 24)) + 1
    : 0;

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!start || !end) {
      setError('Заполните обе даты');
      return;
    }
    if (new Date(end) < new Date(start)) {
      setError('Дата окончания раньше начала');
      return;
    }

    onSave({ start, end });
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-small" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🏖 Отпуск — {employee.full_name}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <div className="form-row">
            <div className="form-group">
              <label>Дата начала</label>
              <input
                type="date"
                value={start}
                onChange={(e) => setStart(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label>Дата окончания</label>
              <input
                type="date"
                value={end}
                onChange={(e) => setEnd(e.target.value)}
                required
              />
            </div>
          </div>

          {days > 0 && (
            <div className="vacation-days-info">
              📅 Длительность: <b>{days} {days === 1 ? 'день' : days < 5 ? 'дня' : 'дней'}</b>
            </div>
          )}

          {error && <div className="login-error">{error}</div>}

          <div className="modal-footer">
            {employee.vacation_start && (
              <button
                type="button"
                className="btn-vacation-modal"
                onClick={() => onSave({ start: null, end: null })}
                title="Убрать отпуск"
              >
                🚫 Отменить отпуск
              </button>
            )}
            <div className="modal-footer-right">
              <button type="button" className="btn-cancel" onClick={onClose}>
                Отмена
              </button>
              <button type="submit" className="btn-save">
                Сохранить
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default VacationForm;